import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import "dayjs/locale/tr";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/nprogress/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/tiptap/styles.css";
import "@mantine/charts/styles.css";
import "./index.css";

import { theme } from "@/theme";
import { queryClient } from "@/lib/queryClient";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AppUpdateModal } from "@/components/AppUpdateModal";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <DatesProvider
        settings={{ locale: "tr", firstDayOfWeek: 1, weekendDays: [0, 6] }}
      >
        <QueryClientProvider client={queryClient}>
          <Notifications position="top-right" />
          <ModalsProvider>
            <BrowserRouter>
              <ErrorBoundary>
                <App />
                <AppUpdateModal />
              </ErrorBoundary>
            </BrowserRouter>
          </ModalsProvider>
        </QueryClientProvider>
      </DatesProvider>
    </MantineProvider>
  </StrictMode>,
);
